const axios = require('../common/axios');
const NewsTemplate = require('./news.hbs');

function Dashboard(url) {
	const targets = {
		EA: '.dashboard .event-audit .card-body',
		UE: '.dashboard .user-events .card-body',
		TA: '.dashboard .team-audit .card-body',
		C: '.dashboard .replies .card-body'
	};

	const pages = {
		EA: 1,
		UE: 1,
		TA: 1,
		C: 1
	};

	function reload(part) {
		const page = pages[part];
		const reloadUrl = `${url}?part=${part}&page=${page}`;
		axios.get(
			reloadUrl,
			{responseType: 'text', headers: {Accept: 'text/html'}}
		).then(
			response => {
				const selector = targets[part];
				if (!selector) {
					throw new Error(`No selector defined for part ${part}!`);
				}
				const element = document.querySelector(targets[part]);
				if (!element) {
					throw new Error(`Could not find element with selector ${selector}!`);
				}
				if (element) {
					element.innerHTML = response.data;
				}
			}
		).catch(
			error => console.warn('Error loading dashboard part', {part, error})
		)
	}

	function news() {
		axios.get('/next/api/news', {responseType: 'json'})
			.then(
				response => {
					const cardBody = document.querySelector('.card.news .card-body');
					if (cardBody) {
						cardBody.innerHTML = NewsTemplate({entries: response.data});
					}
				}
			)
	}

	news();

	return {
		reset: (part, event) =>{
			pages[part] = 1;
			reload(part);
			event.preventDefault();
		},
		next: (part, event) => {
			pages[part]++;
			reload(part);
			event.preventDefault();
		},
		previous: (part, event) => {
			if (pages[part] > 1) {
				pages[part]--;
			}
			reload(part);
			event.preventDefault();
		}
	}
}

module.exports = Dashboard;
